export const ACTIVITY_LIST_COLLAPSED_SIZE = 4;
export const ACTIVITY_LIST_VIRTUALIZATION_THRESHOLD = 50;
export const ACTIVITY_ROW_ESTIMATED_HEIGHT = 76;
export const ACTIVITY_ROW_OVERSCAN = 8;
export const ACTIVITY_NOTE_PREVIEW_LIMIT = 150;
